module.exports = "<nav class=\"c-tabs\">\n    <ul class=\"c-tabs__list\">\n        <li class=\"c-tabs__el\" v-for=\"(tab, index) in tabs\">\n            <button @click=\"selectTab(index)\" @keyup.enter=\"selectTab(index)\" class=\"c-tabs__link\" :class=\"{ 'c-tabs__link--capitalize': capitalize, 'is-selected': selected == index }\">{{tab.name}}</button>\n        </li>\n    </ul>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/tabs/tabs.vhtml
// module id = 315
// module chunks = 0